module.exports = __webpack_public_path__ + "static/typography-hierarchy-401ae3e44837c75571580cc0868ff391.svg";